module.exports = __webpack_public_path__ + "img/three.d79b481f.png";